/* eslint-disable no-unused-expressions */
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const CareerContentPage = () => {
  const { careersApi } = apiPath;
  const { clientCareer } = clientSideUrl;
  const [careerContentData, careerContentLoading] = useFetch(careersApi);
  const { aboutUsCareerList } = RoutePath;

  if (careerContentLoading) {
    return <Loading />;
  }

  const { description, title, sub_title, date, _id } = careerContentData?.find(item => item.slug === "top_banner");

  const data = [
    {
      elementType: "input",
      label: "date",
      type: "Text",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "sub_title",
      defaultValue: sub_title,
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(careersApi, data, _id);
    setTimeout(() => {
      window.location.href = "/" + aboutUsCareerList;
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientCareer}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className=" bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="font-oswald  md:pl-8 font-bold text-2xl  uppercase">
          banner content
        </h1>
        <GlobalForm data={data} update={update} />
      </div>



    </div>
  );
};

export default CareerContentPage;
